import { SelectionFamilyReference, SelectionIndividualEvent } from './internal';
export class SelectionIndividualEventFamily extends SelectionIndividualEvent {
    getFamilyAsChildReference() {
        return this.get("FAMC" /* Tag.FamilyChild */, null, SelectionFamilyReference);
    }
}
//# sourceMappingURL=SelectionIndividualEventFamily.js.map